<template>
  <el-dropdown trigger="click" @command="handleCommand" :hide-on-click="false" class="collection-edit-list-dropdown"
    popper-class="custom-menu-edit-popover-class">
    <span class="dropdown-trigger">
      <slot />
    </span>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item command="publish" v-if="!disabledPublish">Publish</el-dropdown-item>
        <el-dropdown-item command="disable" v-if="!disabledDisable">Disable</el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script setup>

import { ref, watch, getCurrentInstance, onMounted, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { ElDropdown, ElDropdownMenu, ElDropdownItem, ElPopover, ElButton } from 'element-plus';
import { useStorefrontFunction } from '@/components/storefront/StorefrontFunction.js';


const app = getCurrentInstance();
const eventBus = app.appContext.config.globalProperties.EventBus;
const { STATUS_CODE  } = useStorefrontFunction();
const props = defineProps({
  data: {
    type: Array,
    default: []
  },
  type: {
    type: String,
    default: 'collection' // collection, product
  }
});

const popoverVisible = ref(false)
const disabledPublish = computed(() => {
  // if data,but all item are active, disabled active
  if (props.data.filter(e => e.checked).every(item => item.status == STATUS_CODE.Active)) {
    return true;
  }
  return false;
});

const disabledDisable = computed(() => {
  const pickData = props.data.filter(e => e.checked);

  // if all are not Active
  return pickData.every(item => item.status !== STATUS_CODE.Active);
});

//++++++++++++++++++++++++++++++++++++++++++++++

const handleCommand = (command) => {

  popoverVisible.value = false;
  let dataValue = props.data.filter(e => e.checked);
  console.log('dataValue', dataValue);
  let hadSch=dataValue.some(e=>e.status===STATUS_CODE.Scheduled);
  let who_function = props.type==='collection'?'open-storefront-collection-handle-dialog':'open-storefront-product-handle-dialog';
  switch (command) {
    case 'publish':
      if (disabledPublish.value) {
        return;
      }
      
      eventBus.emit(who_function, {
        type: hadSch ? 'PublishSchedule' : 'Publish',
        data: dataValue.filter(e => e.status !== STATUS_CODE.Active)
      });
      return;
    case 'disable':
      if( disabledDisable.value) {
        return;
      }
      eventBus.emit(who_function, {
        type: hadSch ? 'DisabledSchedule' : 'Disabled',
        data: dataValue.filter(e => e.status=== STATUS_CODE.Active)
      });
      return;
    default:
  }
}
onMounted(() => { });

</script>

<style lang="scss">
.custom-menu-edit-popover-class {
  .el-dropdown-menu {
    padding: 8px 0 !important;
  }

  .el-dropdown-menu__item {
    border-radius: 0 !important;

    &:hover {
      background-color: var(--black-40);
      transition: .3s;
    }
  }

  .had-more {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    gap: 16px;

    svg {
      width: 12px;
      height: 12px;
      fill: var(--black-50);
      transition: transform .3s ease-in-out;
      transform: rotate(-90deg);
    }
  }
}

.custom-menu-popover-class {
  transform: translate(10px, 10px) !important;
  padding: 8px 0 !important;

  .el-popper__arrow {
    display: none !important;
  }

  .el-dropdown-menu__item {
    border-radius: 0 !important;
    padding: 0;
  }

  .status-p {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    cursor: pointer;
    width: 100%;
    padding: 8px;

    &:hover {
      background-color: var(--black-10);
      transition: .3s;
    }

    svg {
      width: 12px;
      height: 12px;
      fill: var(--black-50);
      transition: transform .3s ease-in-out;
    }

    &.disabled-status-p {
      opacity: .6;
      cursor: not-allowed;
      pointer-events: none;
    }
  }

}
</style>